// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gray{color:#292727}.store-icon{height:2.7rem;margin-top:0.1rem}.store-icon path,.store-icon rect{fill:#4d4d4d}.store-icon:hover path,.store-icon:hover rect{fill:#dabc64}\n", ""]);
// Exports
module.exports = exports;
